/* The original file is uploaded through Shopify's cart form endpoint. Never store a blob URL in an order. */
window.XZLabelOrder = (() => {
  const root = () => window.Shopify?.routes?.root || '/';
  async function request(path, options = {}) {
    const response = await fetch(root() + path, {credentials:'same-origin',cache:'no-store',...options});
    const data = await response.json();
    if (!response.ok || data.status >= 400) throw new Error(typeof data.description === 'string' ? data.description : 'Shopify could not update your cart. Please try again.');
    return data;
  }
  const postJSON = (path, body) => request(path, {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)});
  function uploadedURL(value) {
    if (typeof value !== 'string') return null;
    try {
      const url = new URL(value, window.location.origin);
      if (url.protocol !== 'https:' || !url.pathname.includes('/uploads/')) return null;
      if (url.origin !== window.location.origin && url.hostname !== 'cdn.shopify.com' && !url.hostname.endsWith('.shopifycdn.com')) return null;
      return url.href;
    } catch { return null; }
  }
  async function rollback(id) {
    const cart = await request('cart.js');
    const updates = Object.fromEntries(cart.items.filter(item => item.properties?._xz_customization === id).map(item => [item.key, 0]));
    if (Object.keys(updates).length) await postJSON('cart/update.js', {updates});
    const finalCart = await request('cart.js');
    if (finalCart.items.some(item => item.properties?._xz_customization === id)) throw new Error('Please review your cart before trying again.');
  }
  async function add({serviceId, variantId, model, configuration, quantity, file, shop, placement, onProgress}) {
    const id = 'XZ-' + crypto.randomUUID();
    const props = {'Customization ID':id,'Machine':model,'Configuration':configuration,'Label placement':placement,'Logo file name':file.name,'Label service':'US$2 per machine',_xz_customization:id,_xz_machine_variant:String(variantId)};
    if (shop) props['Shop name'] = shop;
    try {
      onProgress('Saving your original logo…');
      const form = new FormData();
      form.append('id', serviceId);
      form.append('quantity', quantity);
      Object.entries({...props,_xz_role:'label'}).forEach(([key,value]) => form.append(`properties[${key}]`, value));
      form.append('properties[Logo original]', file, file.name);
      const service = await request('cart/add.js', {method:'POST',headers:{Accept:'application/json'},body:form});
      const logoURL = uploadedURL(service.properties?.['Logo original']);
      if (!logoURL) throw new Error('Your logo file could not be saved. Nothing will proceed to checkout. Please try again or contact our team.');
      onProgress('Adding your machine and checking the label service…');
      await postJSON('cart/add.js', {items:[{id:Number(variantId),quantity,properties:{...props,'Logo original':logoURL,_xz_role:'machine'}}]});
      const cart = await request('cart.js');
      const pair = cart.items.filter(item => item.properties?._xz_customization === id);
      const label = pair.find(item => item.properties._xz_role === 'label');
      const machine = pair.find(item => item.properties._xz_role === 'machine');
      if (pair.length !== 2 || !label || !machine || label.quantity !== quantity || machine.quantity !== quantity || String(label.variant_id) !== String(serviceId) || String(machine.variant_id) !== String(variantId) || !uploadedURL(label.properties['Logo original']) || uploadedURL(machine.properties['Logo original']) !== logoURL) {
        throw new Error('The machine and label service could not be matched. Please try again.');
      }
      return {id,logoURL};
    } catch (error) {
      try { await rollback(id); } catch {
        error.reviewCart = true;
        error.message = 'We could not confirm the cart update. Review your cart before trying again. No payment has been taken.';
      }
      throw error;
    }
  }
  return {add,uploadedURL};
})();
